import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core'
import { FormControl, FormGroup, Validators } from '@angular/forms'
import { HttpErrorResponse } from '@angular/common/http'
import {
  DataCardGroupType,
  DataCardService,
  DataCardType,
} from '../../../../../services/data-card.service'
import { HttpResponseHandlerService } from '../../../../../services/http-response-handler.service'
import { RegexEnum } from '../../../../../enums/regex.enum'

@Component({
    selector: 'app-form-deviation-url',
    templateUrl: './form-deviation-url.component.html',
    standalone: false
})
export class FormDeviationUrlComponent implements OnInit {
  @Input() data: { lastChangedBy: string; lastChanged: string; url: string }
  @Input() mainObject: string
  @Input() isLoading: boolean = false
  @Input() dataCardType: DataCardType
  @Output() notifyDataCard: EventEmitter<any> = new EventEmitter()

  public form: FormGroup<{ url: FormControl<string | null> }>
  public url: FormControl<string | null>

  constructor(
    private service: DataCardService,
    private handlerResponseService: HttpResponseHandlerService,
  ) {}

  public clearDeviationForm(): void {
    this.form.patchValue({
      url: null,
    })
  }

  public onSaveDeviationUrl(): void {
    if (this.form.invalid) {
      return
    }
    const dataCardGroupType: DataCardGroupType = this.service.getDataCardGroupTypeByType(
      this.dataCardType,
    )
    this.service
      .updateDeviationUrl(this.mainObject, { url: this.url.value }, dataCardGroupType)
      .subscribe({
        next: (resource: { data: any; type: DataCardGroupType }) => {
          if (resource.type === 'FE' && resource.data) {
            this.notifyDataCard.next({
              mainObject: this.mainObject,
              active: !!resource.data?.Object_Dev_Active,
              url: resource.data?.Object_Dev_Active,
            })
          }
          this.handlerResponseService.notifySuccess(
            'Success',
            'Deviation URL updated with success!',
          )
        },
        error: (error: HttpErrorResponse) => {
          this.handlerResponseService.notifyError(error)
        },
      })
  }

  private initFormControls(): void {
    this.url = new FormControl<string | null>(null, [
      Validators.maxLength(100),
      Validators.pattern(RegexEnum.REGEX_URL),
    ])
  }

  private initFormGroups(): void {
    this.form = new FormGroup<{ url: FormControl<string | null> }>({
      url: this.url,
    })
  }

  public patchData(): void {
    this.form.patchValue({
      url: this.data?.url,
    })
  }

  ngOnInit(): void {
    this.initFormControls()
    this.initFormGroups()
    this.patchData()
  }
}
